/**
 * @file Functions for making http requests for order detailed
 * @author Max van Loosbroek
 */

import { IHttpResponse, IHttpService, IPromise } from 'angular'
import { URLS } from '../../../../common/utilities/constants/constants.module'
import { parseHttpError } from '../../../../common/utilities/errorHandling'
import { DeclineDto, DetailedTaasOrder, RejectReturnDto } from '../../../overview/types/types'

export const getOrder = ($http: IHttpService, orderId: number | string): IPromise<IHttpResponse<DetailedTaasOrder>> => {
  const url = `${URLS.admin.taasOrders}/${orderId}`
  return $http.get<DetailedTaasOrder>(url).catch(parseHttpError)
}

export const sendStatus = (
  $http: IHttpService,
  orderId: number,
  status:
  | 'accept'
  | 'decline'
  | 'delivered'
  | 'accept-return'
  | 'reject-return',
  body?: DeclineDto | RejectReturnDto
): IPromise<IHttpResponse<DetailedTaasOrder>> => {
  const url = `${URLS.admin.taasOrders}/${orderId}/status/${status}`
  if (body) {
    return $http.post<DetailedTaasOrder>(url, body).catch(parseHttpError)
  } else {
    return $http.post<DetailedTaasOrder>(url, {}).catch(parseHttpError)
  }
}

export const patchTaasOrder = (
  $http: IHttpService,
  orderId: number,
  patch: { trackTraceCode?: string, internalNotes?: string }
): IPromise<IHttpResponse<DetailedTaasOrder>> => {
  const url = `${URLS.admin.taasOrders}/${orderId}`
  return $http.patch<DetailedTaasOrder>(url, patch)
    .catch(parseHttpError)
}
